import { takeLatest, fork, put, call } from 'redux-saga/effects'
import { normalize } from 'normalizr'

import { showSpinner, hideSpinner } from '../../modules/global/actions'

import * as simActions from './actions'
import * as schema from './schema'
import { getAccountId } from '../../utils/helpers'
import { ApiRequest } from '../../utils/api';
import { doCallApi } from '../global/sagas'
import {
  SIMS_FETCH,
  SIM_UPDATE,
  SIM_INFO_UPDATE,
  UPDATE_ORDER,
  CURRENT_ORDER_FETCH,
  CURRENT_SIM_FETCH,
  CURRENT_SIM_POLL,
  NON_ACTIVATED_SIMS_FETCH,
} from './constants'

function* doUpdateSim(action) {
  const { id, data } = action.payload;
  const { response } = yield call(doCallApi, true, ApiRequest.updateSim, id, data);

  if (response) {
    yield put(simActions.receiveCurrentSim(response));
  }
}


function* doUpdateSimInfo(action) {
  const { id, data } = action.payload;

  const { response } = yield call(doCallApi, true, ApiRequest.updateSimInfo, id, data);
  if (response) {
    yield put(simActions.receiveCurrentSim(response));
  }
}


function* doFetchSims(action) {
  const { id } = action.payload;
  yield put(showSpinner());
  const { response } = yield call(doCallApi, true, ApiRequest.getSims, id);
  if (response) {
    const { entities, result } = normalize(response, schema.sims);
    yield put(simActions.receiveSims(entities, result));
  }
  yield put(hideSpinner());
}

function* doUpdateOrder(action) {
  yield put(showSpinner());
  yield call(doCallApi, true, ApiRequest.updateOrder, action.payload);
  yield put(simActions.updateOrderFinished());
  yield put(hideSpinner());
  yield put(simActions.fetchCurrentOrder(getAccountId()));
}

function* doFetchCurrentOrder(action) {
  yield put(showSpinner());
  const { response } = yield call(doCallApi, true, ApiRequest.getCurrentOrder, action.payload.order);
  if (response) {
    yield put(simActions.receiveCurrentOrder(response));
  }
  yield put(hideSpinner());
}

function* doFetchCurrentSim(action) {
  yield put(showSpinner());
  const { response } = yield call(doCallApi, true, ApiRequest.getCurrentSim, action.payload.id);
  if (response) {
    yield put(simActions.receiveCurrentSim(response));
  }
  yield put(hideSpinner());
}

function* doPollCurrentSim(action) {
  const { response } = yield call(doCallApi, true, ApiRequest.getCurrentSim, action.payload.id);
  if (response) {
    yield put(simActions.receiveCurrentSim(response));
  }
}

function* doNonActivatedSimsFetch(action) {
  const { response } = yield call(doCallApi, true, ApiRequest.getNonActivatedSims, action.payload.id);
  if (response) {
    yield put(simActions.receiveNonActivatedSims(response));
  }
}

/**
 */
export function* root() {
  yield fork(takeLatest, SIMS_FETCH, doFetchSims);
  yield fork(takeLatest, SIM_UPDATE, doUpdateSim);
  yield fork(takeLatest, SIM_INFO_UPDATE, doUpdateSimInfo);
  yield fork(takeLatest, UPDATE_ORDER, doUpdateOrder);
  yield fork(takeLatest, CURRENT_ORDER_FETCH, doFetchCurrentOrder);
  yield fork(takeLatest, CURRENT_SIM_FETCH, doFetchCurrentSim);
  yield fork(takeLatest, CURRENT_SIM_POLL, doPollCurrentSim);
  yield fork(takeLatest, NON_ACTIVATED_SIMS_FETCH, doNonActivatedSimsFetch);
}

export default [
  root,
];
